type RecoilSideEffectArguments<T, S> = {
  setSelf: (loadedFromSave: T) => void;
  onSet: (
    func: (newValue: T, oldValue: T | S, isReset: boolean) => void
  ) => void;
};

export const getLocalStorageSideEffect =
  <T, S>(localStorageKey: string) =>
  ({setSelf, onSet}: RecoilSideEffectArguments<T, S>): void => {
    const savedValue = localStorage.getItem(localStorageKey);
    if (savedValue !== null) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      setSelf(JSON.parse(savedValue));
    }

    onSet((newValue, _, isReset) => {
      if (isReset) {
        localStorage.removeItem(localStorageKey);
      } else {
        localStorage.setItem(localStorageKey, JSON.stringify(newValue));
      }
    });
  };
